import { useState } from 'react';

export default function Contact() {
  return (
    <section id="contact" className="py-12 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">Contactez-nous</h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-2">
            Besoin d'un devis ou d'une intervention ? N'hésitez pas à nous contacter
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-12">
          <div className="space-y-4 sm:space-y-6">
            <div className="bg-gray-50 p-5 sm:p-8 rounded-xl">
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-4 sm:mb-6">Informations de contact</h3>
              
              <div className="space-y-4 sm:space-y-5">
                <a href="tel:+33760705475" className="flex items-start gap-3 sm:gap-4 group cursor-pointer">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0 group-hover:bg-teal-200 transition-colors">
                    <i className="ri-phone-line text-lg sm:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm font-medium text-gray-500 mb-0.5 sm:mb-1">Téléphone</div>
                    <div className="text-sm sm:text-base font-semibold text-gray-900 group-hover:text-teal-600 transition-colors">
                      07 60 70 54 75
                    </div>
                  </div>
                </a>

                <a href="mailto:ioncertanpro@gmail.com" className="flex items-start gap-3 sm:gap-4 group cursor-pointer">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0 group-hover:bg-teal-200 transition-colors">
                    <i className="ri-mail-line text-lg sm:text-xl text-teal-600"></i>
                  </div>
                  <div className="min-w-0">
                    <div className="text-xs sm:text-sm font-medium text-gray-500 mb-0.5 sm:mb-1">Email</div>
                    <div className="text-sm sm:text-base font-semibold text-gray-900 group-hover:text-teal-600 transition-colors break-all">
                      ioncertanpro@gmail.com
                    </div>
                  </div>
                </a>

                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-map-pin-line text-lg sm:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm font-medium text-gray-500 mb-0.5 sm:mb-1">Zone d'intervention</div>
                    <div className="text-sm sm:text-base font-semibold text-gray-900">
                      Valence et communes alentour
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-time-line text-lg sm:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm font-medium text-gray-500 mb-0.5 sm:mb-1">Horaires</div>
                    <div className="text-sm sm:text-base font-semibold text-gray-900">
                      Lundi - Samedi : 8h00 - 18h00
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className="ri-star-fill text-lg sm:text-xl text-teal-600"></i>
                  </div>
                  <div>
                    <div className="text-xs sm:text-sm font-medium text-gray-500 mb-0.5 sm:mb-1">Avis clients</div>
                    <div className="flex items-center gap-2">
                      <div className="flex">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <i key={star} className="ri-star-fill text-yellow-400 text-sm sm:text-base"></i>
                        ))}
                      </div>
                      <span className="text-sm sm:text-base font-semibold text-gray-900">5,0 sur Google</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-4 sm:space-y-6">
            <div className="bg-teal-50 p-5 sm:p-8 rounded-xl border border-teal-100">
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2 sm:mb-3">Nous écrire par email</h3>
              <p className="text-xs sm:text-sm text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                Pour toute demande de devis ou question, envoyez-nous un email. Nous vous répondrons dans les plus brefs délais.
              </p>
              <a
                href="mailto:ioncertanpro@gmail.com"
                className="flex items-center gap-3 bg-white border border-teal-200 rounded-lg px-4 sm:px-6 py-3 sm:py-4 hover:bg-teal-100 transition-all group cursor-pointer"
              >
                <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-600 rounded-lg flex-shrink-0">
                  <i className="ri-mail-send-line text-white text-base sm:text-lg"></i>
                </div>
                <span className="text-sm sm:text-base font-semibold text-teal-700 group-hover:text-teal-800 break-all">
                  ioncertanpro@gmail.com
                </span>
              </a>
            </div>

            <div className="bg-teal-600 p-5 sm:p-8 rounded-xl text-white">
              <h3 className="text-base sm:text-lg font-bold mb-2 sm:mb-3">Intervention rapide</h3>
              <p className="text-xs sm:text-sm text-white/90 mb-3 sm:mb-4 leading-relaxed">
                Besoin d'un dépannage urgent ? Contactez-nous directement par téléphone pour une intervention rapide.
              </p>
              <a
                href="tel:+33760705475"
                className="inline-flex items-center justify-center bg-white text-teal-600 px-5 sm:px-6 py-2.5 sm:py-3 rounded-lg text-sm font-semibold hover:bg-teal-50 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Appeler maintenant
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
